export const stripTimeZone = (timeStamp: string): string => {
  return timeStamp.replace("Z", "");
};

export const convertDateToUTC = (incomingDate: Date): string => {
  return stripTimeZone(
    new Date(
      Date.UTC(
        incomingDate.getFullYear(),
        incomingDate.getMonth(),
        incomingDate.getDate(),
        incomingDate.getHours(),
        incomingDate.getMinutes(),
        incomingDate.getSeconds(),
        incomingDate.getMilliseconds(),
      ),
    ).toISOString(),
  );
};

export const getUTCTime = (date?: Date | undefined, offset?: number): number => {
  const newDate = date || new Date();
  const localTimeInMs = newDate.getTime();
  const offsetInMins = offset ?? newDate.getTimezoneOffset();
  const absoluteOffsetInMs = offset ? Math.abs(offset) : Math.abs(offsetInMins) * 60000;

  const utcTimeInMilliseconds = offsetInMins < 0 ? localTimeInMs - absoluteOffsetInMs : localTimeInMs + absoluteOffsetInMs;

  return utcTimeInMilliseconds;
};

export const makeMillLocalTime = (date: Date, offset: number): Date => {
  const utcTimeInMilliseconds = getUTCTime(date, offset);

  return new Date(utcTimeInMilliseconds);
};

/**
 * Converts start and end dates from state to isoStrings. One thing to note here
 * is that the incoming mill's offset value in milliseconds for gmt +n is not a negative value unlike
 * the one javascript gives you with date.getTimezoneOffset()
 * The returned timestamps should be the same values as the ones in the start and end time date time pickers.
 * TODO: Consider using some library for handling time conversion.
 * @param date
 * @param offset
 */
export const timeToUTCTimeStamp = (date: Date, offset: number): { startTimeStamp: string; endTimeStamp: string } => {
  const newDate = date;
  const millTimeInMs = newDate.getTime();
  const localOffsetInMs = newDate.getTimezoneOffset() * 60000;

  const millOffsetInMs = offset;

  let utcTimeInMilliseconds = millTimeInMs;

  if (millOffsetInMs < 0) {
    utcTimeInMilliseconds = localOffsetInMs < 0 ? millTimeInMs + Math.abs(localOffsetInMs) : millTimeInMs - Math.abs(localOffsetInMs);
  } else if (millOffsetInMs > 0) {
    utcTimeInMilliseconds = localOffsetInMs < 0 ? millTimeInMs + Math.abs(localOffsetInMs) : millTimeInMs - localOffsetInMs;
  } else if (millOffsetInMs === 0) {
    utcTimeInMilliseconds = localOffsetInMs < 0 ? millTimeInMs + Math.abs(localOffsetInMs) : millTimeInMs - Math.abs(localOffsetInMs);
  }

  const timeStamps = {
    startTimeStamp: new Date(utcTimeInMilliseconds).toISOString(),
    endTimeStamp: new Date(utcTimeInMilliseconds + 10 * 60000).toISOString(),
  };

  return timeStamps;
};
